import React, {createContext, useContext} from 'react';
import {get, isEqual} from 'lodash';
import {useAuth} from './AuthContext';
import {COMPANY_TYPE} from 'configs/types';
import {OVERLIMIT_STATUS} from 'configs/membership';
import {COMPANY_STATUSES} from 'configs';

const MembershipContext = createContext({});

function MembershipProvider(props) {
  const {children} = props;

  const {account, companyType, isCompany} = useAuth();

  const prevMeta = get(account, 'company.subscription.subscription_plans_meta');
  let subscriptionMeta = get(
    account,
    'company.subscription.subscriptions_meta'
  );

  const billingMethod = get(
    account,
    'company.subscription.subscriptions_billing_method'
  );

  if (!!prevMeta && typeof prevMeta === 'string') {
    subscriptionMeta = JSON.parse(prevMeta);
  }

  const permissions = get(subscriptionMeta, 'features');

  function hasPermit(pathPermit) {
    return get(permissions, pathPermit);
  }

  function getMetaValue(pathMeta) {
    return get(subscriptionMeta, pathMeta);
  }

  const isTrial = get(account, 'company.subscription.is_trial');
  const isTrialDone = get(account, 'company.subscription.trial_done');
  const subscriptionLevel = get(subscriptionMeta, 'level');

  const isSubscribed = subscriptionLevel > 0 && !isTrial;

  const isCE = companyType === COMPANY_TYPE.ce;

  const isVU = isCE || isCompany;
  const isCompanySuspended = isEqual(
    get(account, 'company.company_status'),
    COMPANY_STATUSES.suspended
  );
  const stripeStatus = get(account, 'company.subscription.stripe_status');
  const isSuspendedSubscription =
    isVU &&
    isEqual(stripeStatus, OVERLIMIT_STATUS.unpaid) &&
    isCompanySuspended;

  return (
    <MembershipContext.Provider
      value={{
        hasPermit,
        getMetaValue,
        permissions,
        isSubscribed,
        subscriptionLevel,
        subscriptionMeta,
        isSuspendedSubscription,
        billingMethod,
        isTrial,
        isTrialDone,
        stripeStatus,
      }}
    >
      {children}
    </MembershipContext.Provider>
  );
}

const useMembership = () => useContext(MembershipContext);

export {MembershipContext, MembershipProvider, useMembership};
